import { render, staticRenderFns } from "./Worth.vue?vue&type=template&id=298348c0&scoped=true"
import script from "./Worth.vue?vue&type=script&lang=js"
export * from "./Worth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298348c0",
  null
  
)

export default component.exports